export enum SubscriptionType {
  WandaPlus = 1,
}

export enum PaymentSubscriptionStatus {
  Active = 1,
  Paused = 2,
  Cancelled = 3,
}

export type LookupListItems = {
  value: number;
  label: string;
};

export enum CancelSubscriptionReasons {
  PaymentSubscriptionCancellationReason = "PaymentSubscriptionCancellationReason",
  Other = "Other"
}
export interface SubscriptionPlanData {
  subscriptionTypeId: number;
  personId: number;
  paymentInstrumentId: number;
  organizationId: number;
}

export interface CurrentSubscriptionList {
  paymentSubscriptionId: number;
  paymentInstrumentId: number;
  paymentInstrumentName: string;
  paymentSubscriptionTypeId: number;
  paymentSubscriptionTypeName: string;
  paymentSubscriptionStatusId: number;
  paymentSubscriptionStatusName: string;
  renewOn: string;
  expiresOn: string;
  validUntil: string;
}
